import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';

import './Header.scss';

import Search from '../../containers/ConnectedSearch';

export default class Header extends PureComponent {
    static propTypes = {
        headline: EBPropTypes.translation.isRequired,
        secondary: EBPropTypes.translation,
        align: PropTypes.string,
        hero: PropTypes.string,
        margin: PropTypes.bool,
        heroVerticalAlignCenter: PropTypes.bool,
        defaultHero: PropTypes.bool,
    };

    getClassBasedOnAlignProp(align) {
        switch(align) {
            case 'left':
            default:
                return {
                    headline: 'header--headline',
                    search: 'header--search',
                    image: classNames('header--hero', {
                        'vertical-align-center': this.props.heroVerticalAlignCenter,
                    }),
                };
            case 'center':
                return {
                    headline: 'header--headline center',
                    search: 'header--search center',
                };
        }
    }

    
    render() {

        const classesBasesOnAlignment = this.getClassBasedOnAlignProp(this.props.align);

        const headlineContainerClass = classesBasesOnAlignment.headline;
        const searchContainerClass = classesBasesOnAlignment.search;

        const imageContainerClass = classNames(classesBasesOnAlignment.image, 
            {
                'header--hero__margin': this.props.margin,
            }
        );

        const headerContainerClass = classNames('header-container', {
            'default-hero-image': this.props.defaultHero,
        });

        const headerSecondaryHeadline = classNames('eds-text-hs eds-l-mar-top-4 header-headline__secondary', {
            'always-show': this.props.alwaysShowSecondary,
        });

        return (
            <div className={headerContainerClass}>
                <div className="header-container--headline_search">
                    <div className={headlineContainerClass}>
                        <h1 className="eds-text-hl eds-text-color--primary-brand--hover">
                            {this.props.headline}
                        </h1>
                        <h4 className={headerSecondaryHeadline}>
                            {
                                this.props.secondary ?
                                    this.props.secondary
                                :
                                    null
                            }
                        </h4>
                    </div>
                    
                    <div className={`${searchContainerClass}`}>
                        <Search />
                    </div>
                </div>
                <div className={imageContainerClass}>
                    {
                        (this.props.hero) ?
                            <img src={this.props.hero} alt={this.props.headline} />
                        :
                            null
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js